require("!!/usr/app/node_modules/script-loader/addScript.js")(require("!!/usr/app/node_modules/raw-loader/index.js!/usr/app/node_modules/angular-socialshare/dist/angular-socialshare.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/angular-socialshare/dist/angular-socialshare.min.js
// module id = 35
// module chunks = 2